var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.933,
    cx: 20,
    cy: 20,
    r: 14.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFF",
    d: "M19.9 17.2c.7 0 1.3.6 1.3 1.4V27c0 .8-.6 1.4-1.3 1.4-.7 0-1.3-.6-1.3-1.4v-8.4c.1-.8.6-1.4 1.3-1.4M18 12.8c0-1 .8-1.9 1.9-1.9s1.9.8 1.9 1.9-.8 1.9-1.9 1.9-1.9-.9-1.9-1.9"
  })));
}
SvgInfo.displayName = 'Info';
export default SvgInfo;